<script>
	import { onMount } from 'svelte';
	import { dataset } from './stores.js';
	
	import Home from './pages/Home.svelte'
	import About from './pages/About.svelte' 
	import Compare from './pages/Compare.svelte' 
	import Downloads from './pages/Downloads.svelte' 
	import Analysis from './pages/Analysis.svelte' 
	import Intervention from './pages/Intervention.svelte' 
	import Interventions from './pages/Interventions.svelte' 
	import Profile from './pages/Profile.svelte' 
	import Tools from './pages/Tools.svelte'
	
	let page, pars, route;

	function formatRouteTitle(value) {
		if (!value) return '';

		return value
			.replace(/_/g, ' ')
			.replace(/\bWHO\b/g, 'WHO')
			.replace(/\bSCORE\b/g, 'SCORE')
			.replace(/\b\w/g, (letter) => letter.toUpperCase());
	}

	function getPageTitle(route, pars) {
		if (route == 'downloads' && pars[1]) return formatRouteTitle(pars[1]);
		if (route == 'downloads') return 'Downloads';
		if (route == 'profile' && pars[1]) {
			const countryIso = pars[1].toUpperCase();
			const country = $dataset && $dataset.countries ? $dataset.countries[countryIso] : null;

			return `${country ? country.country : countryIso} - Country Profile`;
		}
		if (route == 'intervention' && pars[1]) return `Intervention - ${pars[1].toUpperCase()}`;
		if (route == 'interventions') return 'Interventions';
		if (route == 'analysis') return 'Country Analysis';
		if (route == 'compare') return 'Compare';
		if (route == 'about') return 'About';
		if (route == 'tools') return 'Tools';

		return 'Map';
	}

	function getDocumentTitle(route, pars) {
		return `${getPageTitle(route, pars)} | WHO SCORE`;
	}

	function trackPageView(pageTitle) {
		if (!window.gtag) return;

		window.gtag('event', 'page_view', {
			page_title: pageTitle,
			page_location: window.location.href,
			page_path: window.location.hash || '/'
		});
	}
	
	async function hashchange() {
		let path = window.location.hash.slice(2) || '/';
		pars = path.split("/");
		route = pars[0] || '';

		if(route=='intervention' && !pars[1]){window.location.hash = '/interventions'; return false;}
		if(route=='profile' && !pars[1]){window.location.hash = '/'; return false;}

		switch(route){
			case 'map': page = Home; break;
			case 'about': page = About; break;
			case 'compare': page = Compare; break;
			case 'downloads': page = Downloads; break;
			case 'analysis': page = Analysis; break;
			case 'intervention': page = Intervention; break;
			case 'interventions': page = Interventions; break;
			case 'profile': page = Profile; break;
			case 'tools': page = Tools; break;
			default: window.location.hash = '/'; page = Home; break;
		}

		const pageTitle = getDocumentTitle(route, pars);
		document.title = pageTitle;
		trackPageView(pageTitle);
	}
	async function loadData(){
		if(!$dataset){
			let r = await fetch(mainscoreassets+"dataset.jsp")
			.then(r=>r.json())
			.then(data=>{
				dataset.set(data);
			});
		}
	}
	loadData();

	let y;
	let currentScrollPosition = 0;
	function scrollWatch(e){
		if(y>currentScrollPosition){
			currentScrollPosition = y;
			document.body.classList.add("scrolled");
			document.body.classList.remove("scrollup");
		}else{
			currentScrollPosition = y;
			document.body.classList.add("scrollup");
			if(y > 0) {
				document.body.classList.add("scrolled");
			}else {
				document.body.classList.remove("scrolled");
				document.body.classList.remove("scrollup");
			}
		}
	}
	
	onMount(()=>{
		hashchange();
	});

</script>
<svelte:window on:hashchange={hashchange} on:scroll={scrollWatch} bind:scrollY={y}/>
<svelte:component this={page} active={route} pars={pars} />
